import React from 'react'

interface EyeIconProps extends React.SVGProps<SVGSVGElement> {
  // draws the slash through the eye
  crossed?: boolean
}

export const EyeIcon: React.FC<EyeIconProps> = ({ crossed, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M1.5 10C3.2 6.4 6.3 4.5 10 4.5s6.8 1.9 8.5 5.5c-1.7 3.6-4.8 5.5-8.5 5.5S3.2 13.6 1.5 10z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle cx="10" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    {crossed && (
      <line
        x1="3.5"
        y1="16.5"
        x2="16.5"
        y2="3.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    )}
  </svg>
)
